import RoutesPage from './Routes/Routes'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'aos/dist/aos.css';
function App() {
  return (
    <div>
      <RoutesPage />
    </div>
    
  );
}

export default App;
